/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PerCoursePaymentAllowedSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('PER_COURSE_PAYMENT_ALLOWED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class PerCoursePaymentAllowedSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PerCoursePaymentAllowedSettingParser.decode(input).map(res => new PerCoursePaymentAllowedSetting(res));
    }
    static unsafeDecode(input) {
        return PerCoursePaymentAllowedSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PerCoursePaymentAllowedSettingParser.encode(data);
    }
    static schema() {
        return PerCoursePaymentAllowedSettingParser.schema();
    }
}
